const $ = require('jquery')
const Backbone = require('backbone')
require('Helpers/plugins')

let resizeTimeoutId
let onResizeBinded

const Win = Backbone.View.extend({
  initialize() {
    this.$html = $('html')
    this.$win = $(window)
    this.$body = $('body')
    this.$doc = $(document)
    this.$wrapper = $('#wrapper')

    // FIRE INITIAL EVENTS
    this.onResize(false)
    this.onScroll(false)

    $(() => {
      // Trigger onResizeEvent after document ready
      setTimeout(() => {
        this.onResize(true)
      }, 500)
    })

    this.registerEvents()
  },

  registerEvents() {
    if (window.MOBILE) {
      this.$win.on('orientationchange', this.onOrientationChange.bind(this))
    }

    this.$win.on('click', this.onClick.bind(this))
    this.$win.on('keyup', this.onKeyup.bind(this))
    this.$win.on('scroll', this.onScroll.bind(this))

    window.onresize = this.onResizeTimeout.bind(this)
  },

  fullscreen(open = undefined) {
    if (open === undefined) {
      this.toggleFullscreen()
    } else if (open) {
      this.enterFullscreen()
    } else {
      this.exitFullscreen()
    }

    this.onResizeTimeout()
  },

  toggleFullscreen() {
    if (this.isFullscreen()) {
      this.exitFullscreen()
    } else {
      this.enterFullscreen()
    }
  },

  enterFullscreen() {
    if (document.documentElement.webkitEnterFullScreen) {
      document.documentElement.webkitEnterFullScreen()
    } else if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen()
    }
  },

  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  },

  isFullscreen: () => document.fullscreenElement,

  isFullscreenEnabled() {
    return !!(document.documentElement.webkitEnterFullScreen || document.documentElement.requestFullscreen)
  },

  setSelectable(selectable) {
    if (selectable) {
      this.$body.removeClass('all-no-selectable')
    } else {
      this.$body.addClass('all-no-selectable')
    }
  },

  onClick(e) {
    if (e.which === 1 || e.which === 0) {
      this.trigger('click', e)
    }
  },

  onResize(shouldTriggerResize) {
    const newWidth = window.innerWidth
    const newHeight = window.innerHeight

    if (newWidth === this.width && newHeight === this.height) {
      return
    }

    this.width = newWidth
    this.height = newHeight

    if (this.width > this.height) {
      this.orientation = 'landscape'
    } else {
      this.orientation = 'portrait'
    }

    if (shouldTriggerResize !== false) {
      this.trigger('resize', [this.width, this.height])
    }
  },

  onOrientationChange() {
    this.onResizeTimeout()
  },

  onResizeTimeout() {
    if (!onResizeBinded) {
      onResizeBinded = this.onResize.bind(this)
    }

    clearTimeout(resizeTimeoutId)
    resizeTimeoutId = setTimeout(onResizeBinded, 20)
    resizeTimeoutId = setTimeout(onResizeBinded, 500)
  },

  scrollTo(y) {
    this.$body.animate(
      {
        scrollTop: y,
      },
      200,
    )
  },

  onScroll(shouldTriggerScroll) {
    this.scrollTop = this.$win.scrollTop()

    if (shouldTriggerScroll !== false) {
      this.trigger('scroll', this.scrollTop)
    }
  },

  onKeyup(e) {
    // console.log('window keyup ' + e.which);
    const k = e.which
    let keySymbol = ''
    if (k >= 96 && k <= 105) {
      keySymbol = k - 96
    } else if (k >= 48 && k <= 57) {
      keySymbol = k - 48
    } else if (k === 13) {
      keySymbol = 'enter'
    }
    this.trigger('keyup', k, e, keySymbol)
  },
})

const win = new Win()

module.exports = win
